import { tKey } from 'ember-intl';

export const ACTION_STATUSES = ['create', 'update', 'delete'] as const;

export type ActionStatus = (typeof ACTION_STATUSES)[number];

export const ACTION_STATUS_TRANSLATION_KEYS: Record<ActionStatus, string> = {
  create: tKey('settings.activity_history.action_status.create'),
  update: tKey('settings.activity_history.action_status.update'),
  delete: tKey('settings.activity_history.action_status.delete'),
} as const;

export const ACTIVITY_ACTION_TRANSLATION_KEYS = {
  password_reset_sent: tKey(
    'settings.activity_history.action.password_reset_sent',
  ),
  nonexisting_password_reset: tKey(
    'settings.activity_history.action.nonexisting_password_reset',
  ),
  inactive_password_reset: tKey(
    'settings.activity_history.action.inactive_password_reset',
  ),
  pw_reset_form_invalid: tKey(
    'settings.activity_history.action.pw_reset_form_invalid',
  ),
  pw_reset_form_valid: tKey(
    'settings.activity_history.action.pw_reset_form_valid',
  ),
  login_inactive: tKey('settings.activity_history.action.login_inactive'),
  login_no_hotels: tKey('settings.activity_history.action.login_no_hotels'),
  login_twofactor: tKey('settings.activity_history.action.login_twofactor'),
  login_twofactor_email: tKey(
    'settings.activity_history.action.login_twofactor_email',
  ),
  login_invalid_loginoption: tKey(
    'settings.activity_history.action.login_invalid_loginoption',
  ),
  login_migrated: tKey('settings.activity_history.action.login_migrated'),
  login_invalid: tKey('settings.activity_history.action.login_invalid'),
  login_success: tKey('settings.activity_history.action.login_success'),
  mfa_email_sent: tKey('settings.activity_history.action.mfa_email_sent'),
  email_updated: tKey('settings.activity_history.action.email_updated'),
  bulkpush_create: tKey('settings.activity_history.action.bulkpush_create'),
  recommendation_action_create: tKey(
    'settings.activity_history.action.recommendation_action_create',
  ),
  restriction_recommendation_action_create: tKey(
    'settings.activity_history.action.restriction_recommendation_action_create',
  ),
  accept_sso: tKey('settings.activity_history.action.accept_sso'),
  compsetrelation_rms_create: tKey(
    'settings.activity_history.action.compsetrelation_rms_create',
  ),
  compsetrelation_rms_delete: tKey(
    'settings.activity_history.action.compsetrelation_rms_delete',
  ),
  compsetrelation_rms_update: tKey(
    'settings.activity_history.action.compsetrelation_rms_update',
  ),
  compsetrelation_app_primary_create: tKey(
    'settings.activity_history.action.compsetrelation_app_primary_create',
  ),
  compsetrelation_app_primary_delete: tKey(
    'settings.activity_history.action.compsetrelation_app_primary_delete',
  ),
  compsetrelation_app_primary_update: tKey(
    'settings.activity_history.action.compsetrelation_app_primary_update',
  ),
  compsetrelation_app_secondary_create: tKey(
    'settings.activity_history.action.compsetrelation_app_secondary_create',
  ),
  compsetrelation_app_secondary_delete: tKey(
    'settings.activity_history.action.compsetrelation_app_secondary_delete',
  ),
  compsetrelation_app_secondary_update: tKey(
    'settings.activity_history.action.compsetrelation_app_secondary_update',
  ),
  user_updated: tKey('settings.activity_history.action.user_updated'),
  user_update_name: tKey('settings.activity_history.action.user_update_name'),
  user_update_language: tKey(
    'settings.activity_history.action.user_update_language',
  ),
  keydate_create: tKey('settings.activity_history.action.keydate_create'),
  keydate_update: tKey('settings.activity_history.action.keydate_update'),
  keydate_delete: tKey('settings.activity_history.action.keydate_delete'),
  keydatenote_create: tKey(
    'settings.activity_history.action.keydatenote_create',
  ),
  keydatenote_update: tKey(
    'settings.activity_history.action.keydatenote_update',
  ),
  keydatenote_delete: tKey(
    'settings.activity_history.action.keydatenote_delete',
  ),
  extrahotelinfo_update_pms: tKey(
    'settings.activity_history.action.extrahotelinfo_update_pms',
  ),
  extrahotelinfo_update_rms: tKey(
    'settings.activity_history.action.extrahotelinfo_update_rms',
  ),
  extrahotelinfo_update_channel_mgr: tKey(
    'settings.activity_history.action.extrahotelinfo_update_channel_mgr',
  ),
  roomtypecompetitormapping_create: tKey(
    'settings.activity_history.action.roomtypecompetitormapping_create',
  ),
  roomtypecompetitormapping_update: tKey(
    'settings.activity_history.action.roomtypecompetitormapping_update',
  ),
  roomtypecompetitormapping_delete: tKey(
    'settings.activity_history.action.roomtypecompetitormapping_delete',
  ),
  reportconfig_create: tKey(
    'settings.activity_history.action.reportconfig_create',
  ),
  reportconfig_update: tKey(
    'settings.activity_history.action.reportconfig_update',
  ),
  reportconfig_delete: tKey(
    'settings.activity_history.action.reportconfig_delete',
  ),
} as const;

export type ActivityActionTranslationKeys =
  keyof typeof ACTIVITY_ACTION_TRANSLATION_KEYS;

export const ACTIVITY_CATEGORY_TRANSLATION_KEYS = {
  account: tKey('settings.activity_history.category.account'),
  competitors: tKey('settings.activity_history.category.competitors'),
  hotel: tKey('settings.activity_history.category.hotel'),
  reports: tKey('settings.activity_history.category.reports'),
  users: tKey('settings.activity_history.category.users'),
  pricing_strategy: tKey('settings.activity_history.category.pricing_strategy'),
} as const;

export type ActivityCategory = keyof typeof ACTIVITY_CATEGORY_TRANSLATION_KEYS;
